<template>
  <div class="roles-main">
    <el-card shadow="never" class="filter-card">
      <div class="search">
        <el-date-picker
          v-model="request.startDate"
          type="datetime"
          placeholder="Start Date"
          format="YYYY/MM/DD"
          value-format="YYYY-MM-DD HH:mm:ss"
          size="small"
          style="width: 170px"
        />
        <el-date-picker
          v-model="request.endDate"
          type="datetime"
          placeholder="End Date"
          format="YYYY/MM/DD"
          value-format="YYYY-MM-DD HH:mm:ss"
          size="small"
          style="width: 170px"
        />
        <el-input
          v-model="request.guestName"
          size="small"
          style="width: 180px"
          placeholder="User Name"
          clearable
        />
        <el-input
          v-model="request.guestIp"
          size="small"
          style="width: 160px"
          placeholder="IP"
          clearable
        />
        <el-input
          v-model="request.guestId"
          size="small"
          style="width: 160px"
          placeholder="Guest ID"
          clearable
        />
        <el-select
          clearable
          v-model="request.agentName"
          size="small"
          placeholder="Agent"
          style="width: 180px"
        >
          <el-option
            v-for="item in agentList"
            :key="item"
            :label="item"
            :value="item"
          />
        </el-select>
        <el-select
          clearable
          v-model="request.finishType"
          size="small"
          placeholder="Finish Type"
          style="width: 240px"
        >
          <el-option
            v-for="item in uiControl.finishType"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
        <el-select
          v-model="request.guestRatings"
          multiple
          collapse-tags
          placeholder="Rating"
          size="small"
          style="width: 200px"
        >
          <el-option
            v-for="rating in uiControl.ratings"
            :key="rating"
            :value="rating"
            :label="rating"
          >
            <star-rating :rating="rating" :read-only="true" star-size="10" inline="true" />
          </el-option>
        </el-select>
        <treeselect
          v-model="selectWrapUp"
          :multiple="true"
          :options="queryWrapUpList"
          placeholder="Wrap-Up"
          :max-height="260"
          style="width: 400px;min-height: 32px;"
        />
      </div>
      <div class="filter-actions">
        <el-button
          icon="el-icon-search"
          size="small"
          type="success"
          @click="loadRoom()"
        >
          Search
        </el-button>
        <el-button
          icon="el-icon-refresh"
          size="small"
          type="warning"
          @click="resetQuery()"
        >
          Reset
        </el-button>
        <el-tooltip content="Download Excel" placement="top">
          <span>
            <el-button
              icon="el-icon-download"
              size="small"
              type="primary"
              :loading="downloading"
              @click="download()"
            />
          </span>
        </el-tooltip>
      </div>
    </el-card>

    <el-card shadow="never" class="section-card">
      <div class="card-head">
        <span class="card-title">Conversations</span>
        <span class="card-badge">Total Pages: {{ page.pages }}</span>
      </div>
      <el-table
        v-loading="loading"
        :data="page.records"
        ref="table"
        row-key="id"
        size="small"
        border
        class="beauty-table"
        highlight-current-row
        empty-text="No data"
      >
        <el-table-column
          label="Guest Name"
          min-width="150"
          align="left"
          show-overflow-tooltip
        >
          <template #default="scope">
            <el-link
              type="primary"
              :underline="false"
              @click="showDetail(scope.row.id)"
            >
              {{ scope.row.guestName || '-' }}
            </el-link>
          </template>
        </el-table-column>
        <el-table-column
          prop="guestIp"
          label="IP"
          min-width="130"
          align="left"
          show-overflow-tooltip
        />
        <el-table-column
          label="Country"
          min-width="150"
          align="left"
          show-overflow-tooltip
        >
          <template #default="scope">
            {{ formatLocation(scope.row.country, scope.row.province) }}
          </template>
        </el-table-column>
        <el-table-column
          label="Agent"
          min-width="120"
          align="left"
          show-overflow-tooltip
        >
          <template #default="scope">
            <span>{{ (scope.row.agentNickNameList && scope.row.agentNickNameList.length) ? scope.row.agentNickNameList.join(', ') : '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="Wrap-Up"
          min-width="160"
          align="left"
          show-overflow-tooltip
        >
          <template #default="scope">
            <el-link
              v-if="scope.row.wrapUps && scope.row.wrapUps.length > 0"
              type="primary"
              :underline="false"
              @click="editorWrapUp(scope.row.id, scope.row.wrapUp)"
            >
              {{ scope.row.wrapUps.join(', ') }}
            </el-link>
            <el-link
              v-else
              type="info"
              :underline="false"
              @click="editorWrapUp(scope.row.id, scope.row.wrapUp)"
            >
              no wrap-up
            </el-link>
          </template>
        </el-table-column>
        <el-table-column
          label="Create Time"
          min-width="170"
          align="left"
        >
          <template #default="scope">
            <span
              v-formatter="{
                data: scope.row.createTime,
                formatter: 'YYYY/MM/DD HH:mm:ss',
                type: 'date',
              }"
            />
          </template>
        </el-table-column>
        <el-table-column
          label="Finish Type"
          min-width="200"
          align="center"
          header-align="center"
        >
          <template #default="scope">
            <el-tag
              size="small"
              effect="light"
              :type="finishTypeTagType(scope.row.finishType)"
            >
              {{ getFinishReason(scope.row.finishType) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
          label="Finish Time"
          min-width="170"
          align="left"
        >
          <template #default="scope">
            <span
              v-formatter="{
                data: scope.row.finishTime,
                formatter: 'YYYY/MM/DD HH:mm:ss',
                type: 'date',
              }"
            />
          </template>
        </el-table-column>
        <el-table-column
          label="Rating"
          width="150"
          align="center"
          header-align="center"
        >
          <template #default="scope">
            <star-rating
              v-if="scope.row.guestRating"
              v-model:rating="scope.row.guestRating"
              :read-only="true"
              star-size="10"
              inline="true"
              :show-rating="false"
            />
            <span v-else>-</span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="pagination"
        @current-change="changePage"
        layout="prev, pager, next, jumper"
        :page-size="request.size"
        :page-count="page.pages"
        :current-page="request.current"
      />
    </el-card>

    <el-drawer
      v-model="drawer"
      title="Conversation Detail"
      :with-header="false"
      :destroy-on-close="true"
      size="50%"
      :open-delay="300"
    >
      <roomDetail :roomId="showRoomId" />
    </el-drawer>

    <el-dialog
      title="Update WrapUp"
      v-model="uiControl.dialogVisible"
      append-to-body
      width="600px"
      destroy-on-close
    >
      <el-form
        ref="menuForm"
        :model="form"
        :inline="true"
        size="small"
        label-width="150px"
      >
        <el-form-item label="WrapUp" style="position: relative; display: flex;align-items: center;justify-content: end;">
          <treeselect v-model="wrapUpForm.wrapUp"
                      :multiple="true"
                      :options="wrapUpList"
                      :disable-branch-nodes="true"
                      :clear-on-select="true"
                      placeholder="wrapup"
                      style="width: 300px;margin:2px;min-height: 32px;z-index: 9999"
          />
        </el-form-item>
      </el-form>
      <div class="dialog-footer">
        <el-button size="small" @click="uiControl.dialogVisible=false">Cancel</el-button>
        <el-button size="small" @click="updateWrapUp" type="primary">
          Confirm
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script setup>
import { computed, onMounted, reactive, ref } from '@vue/runtime-core'
import {
  downloadRooms,
  roomFinishReason,
  roomFinishType,
  getAgents,
  getSiteRoom,
  getFinishReason,
} from '../../../../api/room'
import { convertDateTime, convertDate, exportExl2 } from '@/utils/util'
import { store } from '../../../../store'
import { map, startsWith } from 'lodash'
import { Treeselect } from 'vue3-treeselect'
import 'vue3-treeselect/dist/vue3-treeselect.css'
import { getWrapUp, updateRoomWrapUp } from "../../../../api/wrap-up";
import StarRating from "vue-star-rating";
import roomDetail from '../details'
import { ElMessage } from "element-plus";

const uiControl = reactive({
  finishType: roomFinishReason,
  ratings: [1, 2, 3, 4, 5],
  dialogVisible: false
})

const drawer = ref(false)
const selectWrapUp = ref(null)
const showRoomId = ref(null)
const loading = ref(false)
const downloading = ref(false)

const userSiteId = computed(() => {
  return store.state.user.siteId
})

const wrapUpForm = reactive({
  id: null,
  wrapUp: null,
})
const request = reactive({
  size: 30,
  current: 1,
  agentName: null,
  finishType: null,
  siteId: userSiteId.value,
  startDate: convertDateTime(new Date().setHours(0, 0, 0, 0)),
  endDate: convertDateTime(new Date().setHours(23, 59, 59, 999)),
  guestName: null,
  guestId: null,
  guestIp: null,
  wrapUp: null,
  guestRatings: [],
})

const page = reactive({
  pages: 0,
  records: [],
})

const agentList = ref([])
const wrapUpList = ref([])
const queryWrapUpList = ref([])

function resetQuery() {
  request.agentName = null
  request.guestName = null
  request.guestId = null
  request.guestIp = null
  request.finishType = null
  request.guestRatings = []
  request.wrapUp = null
  selectWrapUp.value = null
}

function editorWrapUp(id, wrapUp) {
  uiControl.dialogVisible = true;
  wrapUpForm.wrapUp = wrapUp ? wrapUp.split(",") : [];
  wrapUpForm.id = id;
}

async function updateWrapUp() {
  updateRoomWrapUp({ id: wrapUpForm.id, wrapUp: wrapUpForm.wrapUp.join(",") }).then((d) => {
    if (d.code === 0) {
      uiControl.dialogVisible = false;
      ElMessage({ message: 'Update Successful', type: 'success' });
      wrapUpForm.id = null;
      wrapUpForm.wrapUp = null;
      loadRoom();
    }
  })
}

function getWrapupChildren(parentId) {
  let children = parentId;
  wrapUpList.value.forEach(value => {
    if (value.id === parentId && value.children) {
      children = value.children.map((v) => {
        return v.id;
      });
    }
  });
  return children;
}

function changePage(page) {
  request.current = page
  loadRoom()
}

function showDetail(roomId) {
  drawer.value = true
  showRoomId.value = roomId
}

// country/province 兜底, 避免 'null | xxx'
function formatLocation(country, province) {
  const c = country || ''
  const p = province || ''
  if (c && p) return `${c} | ${p}`
  return c || p || '-'
}

// finishType -> el-tag type 颜色映射(未知兜底 info; ROBOT 用默认主色 '')
function finishTypeTagType(type) {
  switch (type) {
    case roomFinishType.CS_CLOSE:
    case roomFinishType.GUEST_CLOSE:
      return 'success'
    case roomFinishType.ROBOT:
      return ''
    case roomFinishType.LONG_IDLE:
      return 'warning'
    case roomFinishType.GUEST_LEAVE:
    case roomFinishType.NOT_MATCHED:
      return 'danger'
    default:
      return 'info'
  }
}

async function download() {
  if (downloading.value) return
  downloading.value = true
  try {
    const downloadRequest = { ...request, size: -1 };
    const { data: list } = await downloadRooms(downloadRequest)
    const json = []
    list.records.forEach((item) => {
      const finishTime = convertDateTime(item.finishTime)
      let content = formatMessage(item.message)

      content += `\n\r ( end at ${finishTime})`
      json.push({
        name: item.guestName,
        ip: item.guestIp,
        id: item.guestId,
        agent: (item.agentNickNameList || []).join(),
        wrapup: (item.wrapUps || []).join(),
        matchTime: convertDateTime(item.createTime),
        finishTime: finishTime,
        finishType: getFinishReason(item.finishType),
        rating: item.guestRating,
        message: content,
      })
    })
    const cols = [
      { header: 'name', key: 'name', width: 20 },
      { header: 'ip', key: 'ip', width: 20 },
      { header: 'id', key: 'id', width: 20 },
      { header: 'agent', key: 'agent', width: 20 },
      { header: 'wrapup', key: 'wrapup', width: 30 },
      { header: 'matchTime', key: 'matchTime', width: 30 },
      { header: 'finishTime', key: 'finishTime', width: 20 },
      { header: 'finishType', key: 'finishType', width: 20 },
      { header: 'rating', key: 'rating', width: 5 },
      { header: 'message', key: 'message', width: 20 },
    ]

    const fileName = `${convertDate(request.startDate)}-${convertDate(request.endDate)}.xls`
    exportExl2(json, fileName, cols)
  } catch (e) {
    ElMessage.error('Download failed')
  } finally {
    downloading.value = false
  }
}

function formatMessage(messages) {
  return map(messages, item => {
    if (item.cmd !== 4) {
      return ''
    }

    item = item.body

    let outputStr = ''
    let content = ''

    const name = item.senderName ?? 'sys'

    if (startsWith(item.senderId, 'gt_')) {
      outputStr += `(guest) guest`
    } else {
      outputStr += `(cs) ${name}`
    }

    if (item.ts) {
      outputStr += `[${convertDateTime(new Date(item.ts))}]`
    }

    outputStr += ':'

    if (item.type === 'options') {
      content += '[options]'
    } else if (item.type === 'option_selected') {
      if (item.meta.items && item.meta.items.length) {
        content += item.meta.items[0]?.name
      }
    } else {
      content += item.msg
    }

    if (item.type === 'file') {
      if (item.files && item.files[0]) {
        const file = item.files[0]

        content += `File ${file.url}`
      }
    }

    if (content) {
      outputStr += content
    }

    return outputStr
  }).join('\n\r')
}

async function loadRoom() {
  loading.value = true
  try {
    if (selectWrapUp.value && selectWrapUp.value.length > 0) {
      request.wrapUp = selectWrapUp.value.map((warpupId) => {
        return getWrapupChildren(warpupId);
      }).join(",");
    } else {
      request.wrapUp = null;
    }
    const { data: ret } = await getSiteRoom(request)
    page.pages = ret.pages
    page.records = ret.records
  } catch (e) {
    ElMessage.error('Failed to load conversations')
  } finally {
    loading.value = false
  }
}

async function initData() {
  const { data: ret } = await getAgents({ siteId: userSiteId.value })
  agentList.value = ret

  const { data: menus } = await getWrapUp({ parentId: -1, mode: 1 })
  wrapUpList.value = menus.map((menu) => {
    if (menu.children) {
      return {
        id: menu.id,
        label: menu.name,
        children: menu.children.map((child) => {
          return { id: child.id, label: child.name };
        })
      };
    } else {
      return { id: menu.id, label: menu.name };
    }
  });
  queryWrapUpList.value = wrapUpList.value.slice();
  // add no wrapup
  queryWrapUpList.value.push({ id: -1, label: 'noWrapUp' })
}

onMounted(async () => {
  initData()
  loadRoom()
})
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.filter-card {
  margin-bottom: 16px;
  border-radius: 8px;
  overflow: visible;
}
.filter-card :deep(.el-card__body) {
  padding: 16px 18px;
  overflow: visible;
}
.search {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
}
.filter-actions {
  display: flex;
  gap: 10px;
  margin-top: 12px;
}
.section-card {
  border-radius: 10px;
  margin-bottom: 16px;
}
.section-card :deep(.el-card__body) {
  padding: 16px 18px;
}
.card-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 14px;
}
.card-title {
  font-size: 15px;
  font-weight: 600;
  color: var(--el-text-color-primary, #303133);
}
.card-badge {
  font-size: 12px;
  color: var(--el-text-color-secondary, #909399);
  font-variant-numeric: tabular-nums;
}
.beauty-table :deep(thead th) {
  background: #f5f7fa;
  font-weight: 600;
  color: var(--el-text-color-primary, #303133);
}
.num-cell {
  font-variant-numeric: tabular-nums;
}
.pagination {
  display: flex;
  justify-content: flex-end;
  margin-top: 14px;
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
}

:deep(.vue-treeselect__control) {
  min-height: 32px;
  height: auto;
}
</style>
